import { normalizePathname } from '@zapier/url-utils';

// Indicates whether the given `href` should be considered selected
// based on the value of `selectedHref`. The rules of this are somewhat
// specific to `UniversalSidebar`, so be careful if you try to make
// this more generic!
export const isLinkSelected = (linkHref: string, currentPageHref: string) => {
  let parsedCurrentPageHref;
  let parsedLinkHref;

  try {
    parsedCurrentPageHref = new URL(currentPageHref);
    parsedLinkHref = new URL(linkHref);
  } catch {
    // no-op
  }

  // Handle relative link URLs
  if (!parsedLinkHref) {
    return normalizePathname(
      parsedCurrentPageHref?.pathname || currentPageHref
    ).startsWith(normalizePathname(linkHref));
  }

  // Handle absolute link URLs
  return normalizePathname(currentPageHref).startsWith(
    normalizePathname(linkHref)
  );
};
